export const DEFAULT_CATEGORY_NAME = "default";
export const DEFAULT_SORTING_ORDER_NUMBER = 99;
export const DIMENSION_SORT_ORDER_NAME = "order";
